import { useMemo } from 'react';
import { GlobalButton, NavigateLinks } from '@/components';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { Add as AddIcon } from '@mui/icons-material';
import { SearchBar, UsersTable } from './components';
import { useNavigate } from 'react-router-dom';
import { childrenInventoryPageBreadcrumbs } from '../../config';
import { useUsersFilter } from './hooks';
import { UsersFilter } from './models';

import styles from './Users.module.css';
export const Users = () => {
  const navigate = useNavigate();
  const breadcrumbs = useMemo(
    () => childrenInventoryPageBreadcrumbs(navigate),
    []
  );

  const { filter, setFilter, initialFilter } = useUsersFilter();

  const handleUserSearch = (filters: UsersFilter) => {
    setFilter(filters);
  };

  return (
    <section className={styles.container}>
      <NavigateLinks actualPage='Usuarios' breadcrumbs={breadcrumbs} />
      <div className={styles.actions}>
        <GlobalButton
          variant={GlobalButtonVariant.primaryButton}
          action={() => navigate('create')}
        >
          <AddIcon />
          Agregar usuario
        </GlobalButton>
      </div>
      <SearchBar onSearch={handleUserSearch} initialFilter={initialFilter} />
      <UsersTable usersFilter={filter} />
    </section>
  );
};

export default Users;
